export const TYPES = {
  images: {
    tabText: 'Images',
    contentTypeRegex: /^image\//,
  },
  documents: {
    tabText: 'Documents',
    contentTypeRegex: /^(application|text)\//,
  },
  media: {
    tabText: 'Media',
    contentTypeRegex: /^(video|audio)\//,
  },
  other: {
    tabText: 'Other',
  },
};

export function getType(contentType) {
  if (TYPES.images.contentTypeRegex.test(contentType)) {
    return 'images';
  } else if (TYPES.documents.contentTypeRegex.test(contentType)) {
    return 'documents';
  } else if (TYPES.media.contentTypeRegex.test(contentType)) {
    return 'media';
  } else {
    return 'other';
  }
}



// WEBPACK FOOTER //
// ./src/ui/asset-library/asset-types.js